import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import Brand from 'models/brand';

import ParkingPassCancelButton from 'components/parking-passes/parking-instructions/pass-actions/cancel-button';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
};

class PassActions extends Component {
  renderCancelLink() {
    const { brand, parkingPass } = this.props;

    if (!parkingPass.displayCancelLink) {
      return null;
    }

    return (
      <ParkingPassCancelButton
        brand={brand}
        parkingPass={parkingPass}
      />
    );
  }

  renderHelpLinks() {
    const { brand, parkingPass } = this.props;

    const sharedClasses = [
      'col-xs-12',
      'col-md-2',
      'margin-bottom-15',
      'border-color-grey',
      'border-style-sm-solid',
      'border-width-1',
    ];

    const helpLinkClasses = cx(
      sharedClasses,
      'border-side-right',
      { 'border-side-left': parkingPass.displayCancelLink },
    );

    return (
      <Fragment>
        <a
          href={brand.helpWebsiteURL}
          target="_blank"
          rel="noopener noreferrer"
          className={helpLinkClasses}
        >
          <FormattedMessage id="parking-pass.help-and-contact" defaultMessage="Contact Us" />
        </a>
        <a
          href={`tel:${brand.helpPhone}`}
          className={cx(sharedClasses)}
        >
          { brand.helpPhone }
        </a>
      </Fragment>
    );
  }

  render() {
    return (
      <div className="hidden-print row text-align-sm-center text-weight-book with-vertical-margin with-vertical-margin-2x-gte-md">
        { this.renderCancelLink() }
        { this.renderHelpLinks() }
      </div>
    );
  }
}

PassActions.propTypes = propTypes;
export default PassActions;
